import { TreeItem, TreeView } from "@mui/lab";
import { Box, Button, Dialog, DialogContent, Divider, Typography } from "@mui/material";
import { useMap } from "react-leaflet";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Fragment } from "react";
import { useRouteSettings, useRouteSettingsActions } from '../../stores/RouteSettingsStore';

export interface IRoadFeatureDialogProps {
    feature: any,
    isOpen: boolean,
    onClose: () => void;
}

export function RoadFeautureDialog(props: IRoadFeatureDialogProps) {
    const { isOpen, onClose } = props;
    const map = useMap();

    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();


    const handleClose = (_event: any, _reason: string) => {
        map.scrollWheelZoom.enable();
        onClose();
    }

    const avoidFeatureInstance = () => {
        setRouteSettings({
            ...routeSettings,
             avoidFeatureInstanceIds: addAvoidFeatureInstance(routeSettings.avoidFeatureInstanceIds, props.feature.avoidFeatureInstanceId)
            });
    };
    
    return (
        <Dialog style={{zIndex: 11000}} open={isOpen} onClose={handleClose} maxWidth={"xl"}>
            <DialogContent>
                <Box className={"featureDialogGrid"}>
                    <Typography>Egenskap</Typography>
                    <Typography>Verdi</Typography>
                    <div className="featureDialogGridDivider"> <Divider /></div>
                    {props.feature && Object.keys(props.feature).map( (key, index) => {
                        return (
                            <Fragment key={key + index.toString()}>                                                         
                                <Typography style={{wordBreak: "break-all"}}>{key}</Typography>
                                {renderTableCell(props.feature[key])}
                                <div className="featureDialogGridDivider"> <Divider /></div>
                            </Fragment>
                        )
                    })}
                </Box>
                <Button onClick={avoidFeatureInstance} variant="contained">
                    Unngå objekt
                </Button>
            </DialogContent>
        </Dialog>
    )
}

function addAvoidFeatureInstance(currentValue: string | null, newValue: string) {
    if(currentValue) {
        if(currentValue?.includes(newValue)) {
            return currentValue;
        }
        return currentValue + "," + newValue;
    }

    

    return newValue;
}

function valueAsObject(value: any) {
    if (value === Object(value)) {
        return value;
    }

    if (typeof(value) === "string") {

        try {
            const obj = JSON.parse(value);

            if (typeof obj === "number") {
                return undefined;
            }

            return obj;
        } catch {
            return undefined;
        }
    }    

    return undefined;
}

function renderTableCell(value: any) {

   
    const data = valueAsObject(value);

    try {
        if (data) {
            return (
                <div>
                    <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
                        {renderTreeItem(getValue(data), data)}
                    </TreeView>
                </div>
            )
        }
    }   catch (error) {
    }

    return (<Typography>{value ? getValue(value).toString() : "Ingen verdi"}</Typography>);
}

function renderTreeItem(key: string, value: any, level: number = 0, iteration: number = 0) : any {
    //if this is the first level, we want to skip over it to the 2nd level of the tree
    if (level === 0) {
        return Object.keys(value).map( (key) => {
            return renderTreeItem(key, value[key], level + 1);
        })
    }

    if (value === Object(value)) {        
      return(
            <TreeItem 
                key={`${key + level.toString() + iteration.toString()}`} 
                nodeId={`${key + level.toString() + iteration.toString()}`} 
                label={`${key}`}>
                {
                    Object.keys(value).map( (key, index) => {
                        return renderTreeItem(key, value[key], level + 1, index);
                    })
                }
            </TreeItem>
        )
    }

    return <TreeItem 
                key={`${key + level.toString() + iteration.toString()}`} 
                nodeId={`${key + level.toString() + iteration.toString()}`} 
                label={key + ": " + JSON.stringify(value)} 
            />;
}

function getValue(value: any) {
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    return value;
}